import Vue from 'vue'
import App from './App.vue'
// 引入 swiper.css
import 'swiper/css/swiper.css'
// 引入图标
import './assets/iconfont/iconfont.css'
import './assets/css/common.css'
// 引入 route
import router from './route'
// 引入store
import store from './store'
// 引入ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 引入axios
import axios from './axios'
// 引入v-md-preview
import VMdPreview from '@kangc/v-md-editor/lib/preview'
import '@kangc/v-md-editor/lib/style/preview.css'
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js'
import '@kangc/v-md-editor/lib/theme/style/github.css'

// highlightjs
import hljs from 'highlight.js'

// import * as xhrs from './axios/request'

VMdPreview.use(githubTheme, {
	Hljs: hljs,
})

Vue.use(VMdPreview)
Vue.use(ElementUI)

Vue.config.productionTip = false
Vue.prototype.$axios = axios
// Vue.prototype.$xhrs = xhrs

new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')
